import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './quick-register.reducer';

import { SettingsStateKeys } from '@libs/entity-lib';

export const selectProfileState = createFeatureSelector<fromReducer.State>(
  SettingsStateKeys.QUICK_USER
);

export const selectState = createSelector(selectProfileState, (state) => state);

export const selectUserState = createSelector(selectProfileState, (state) => state?.quickUser);

export const selectIsLoading = createSelector(
  selectProfileState,
  (state): boolean => state?.loading ?? false
);
